import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import ContactsPeopleSelectionModal from 'components/selection_modals/contacts_people';
import ContactsPropertiesSelectionModal from 'components/selection_modals/contacts_properties';
import CallListSelectionModal from 'components/selection_modals/call_list';
import ProjectsSelectionModal from 'components/selection_modals/projects';
import TaskIcon from 'components/tasks/task_icon';

import '../../styles/contacts.scss';
import { Badge, Form } from 'react-bootstrap-5';

export default class EditTaskForm extends React.Component {
  static propTypes = {
    callListsAccess: PropTypes.bool.isRequired,
    canFollowUp: PropTypes.bool,
    defaultTaskAssignee: PropTypes.object,
    followUp: PropTypes.bool,
    isCompleted: PropTypes.bool,
    person: PropTypes.object,
    task: PropTypes.object.isRequired,
    onAddAssociation: PropTypes.func.isRequired,
    onRemoveAssociation: PropTypes.func.isRequired,
    onRemoveTaskListAssociation: PropTypes.func.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    onToggleFollowUp: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {
      showPeopleModal: false,
      showPropertiesModal: false,
      showProjectsModal: false,
      showCallListModal: false
    };
  }

  handleTaskBodyChange = e => this.props.onTaskChange(e.target.value, "body")

  associateCallListsToTask = (callLists) => {
    const { task } = this.props;

    callLists.forEach((cl) => {
      cl.task_list_id = cl.id;
      cl.task_id = task.id;
      delete cl.id;
      delete cl.tasks;
    });

    this.props.onTaskChange(callLists, "taskListItems");
    this.closeModals();
  }

  openPeopleModal = () => {
    this.setState({
      showPeopleModal: true
    });
  }

  openPropertiesModal = () => {
    this.setState({
      showPropertiesModal: true
    });
  }

  openProjectsModal = () => {
    this.setState({
      showProjectsModal: true
    });
  }

  openCallListModal = () => {
    this.setState({
      showCallListModal: true
    });
  }

  closeModals = () => {
    this.setState({
      showCallListModal: false,
      showPeopleModal: false,
      showProjectsModal: false,
      showPropertiesModal: false
    });
  }

  associateToTask = (associations, model) => {
    this.props.onAddAssociation(associations, model);
    this.closeModals();
  };

  render() {
    const {
      canFollowUp,
      followUp,
      onToggleFollowUp,
      task
    } = this.props;

    const {
      showPeopleModal,
      showPropertiesModal,
      showCallListModal,
      showProjectsModal
    } = this.state;

    const associatedModels = task.associatedModels || [];

    const associatedPeople = associatedModels.filter(model => model.associatedModelType === "Contacts::Person");
    const associatedProperties = associatedModels.filter((model) => {
      return model.associatedModelType === "Research::Property";
    });
    const associatedProjects = associatedModels.filter(model => model.associatedModelType === "Project");

    return (
      <div>
        <div className="d-flex mb-1">
          <div className="d-flex border w-100 p-2 ps-3 align-items-center justify-content-between mb-1">
            <div>
              {task.title}
            </div>
            <div>
              <TaskIcon size="xs" type="call"/>
            </div>
          </div>
        </div>
        {this.renderTextArea()}
        {this.renderAssociationSelectors()}
        {this.renderAssociatedContacts()}
        {canFollowUp &&
          <Form.Check
            checked={followUp}
            inline
            label="Create a follow-up Task"
            name="follow-up-check"
            type="checkbox"
            onChange={onToggleFollowUp}
          />
        }
        <ContactsPeopleSelectionModal
          modalTitle="Add people to the task"
          selectedItems={associatedPeople || []}
          show={showPeopleModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Contacts::Person")}
        />
        <ContactsPropertiesSelectionModal
          modalTitle="Add properties to the task"
          selectedItems={associatedProperties || []}
          show={showPropertiesModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Research::Property")}
        />
        <CallListSelectionModal
          modalTitle="Add call lists to the task"
          selectedItems={task.taskListItems || []}
          show={showCallListModal}
          onCancel={this.closeModals}
          onOk={this.associateCallListsToTask}
        />
        <ProjectsSelectionModal
          modalTitle="Add projects to the task"
          selectedItems={associatedProjects || []}
          show={showProjectsModal}
          onCancel={this.closeModals}
          onOk={e => this.associateToTask(e, "Project")}
        />
      </div>
    );
  }

  renderAssociationSelectors() {
    const { callListsAccess, task } = this.props;
    const associatedModels = task.associatedModels || [];

    const associatedProjects = associatedModels.filter(model => model.associatedModelType === "Project");

    return (
      <div className="d-flex align-items-center gap-3 mt-1">
        <a href="javascript:void(0)" onClick={this.openPeopleModal}>
          + Contact
        </a>
        <a href="javascript:void(0)" onClick={this.openPropertiesModal}>
          + Property
        </a>

        {associatedProjects.length === 0 &&
          <a href="javascript:void(0)" onClick={this.openProjectsModal}>
            + Project
          </a>
        }
        {(task.taskType === "call" && callListsAccess) &&
          <a href="javascript:void(0)" onClick={this.openCallListModal}>
            + List
          </a>
        }
      </div>
    );
  }

  renderAssociatedContacts() {
    const {
      task,
      person,
      onRemoveTaskListAssociation
    } = this.props;

    const contacts = [];

    (task.associatedModels || []).forEach((association) => {
      if (person && association.associatedModelId == person.id
        && association.associatedModelType === person.contactType) {
        contacts.push(
          <Badge
            bg=""
            className="badge-primary badge-muted"
            key={`${association.modelType}${association.id}`}
          >
            {association.name}
          </Badge>
        );
      } else {
        if (association.associatedModelId === association.originalId) {
          contacts.push(
            this.renderAssociatedTag(association.associatedModelId, association.name, association.associatedModelType)
          );
        }
      }
    });

    if (task.taskListItems) {
      contacts.push(task.taskListItems.map((association) => {
        return (
          <Badge
            bg=""
            className="badge-primary badge-muted"
            key={`${association.modelType}${association.id}`}
          >
            List: {association.name}
            <FontAwesomeIcon
              className="ms-2 clickable"
              icon={faTimes}
              size="sm"
              onClick={() => onRemoveTaskListAssociation(association.id)}
            />
          </Badge>
        );
      }));
    }

    return (
      <div className="d-flex align-items-center gap-2 my-2">
        {contacts}
      </div>
    );
  }

  renderAssociatedTag(id, name, model) {
    const { onRemoveAssociation } = this.props;
    return (
      <Badge bg="" className="badge-primary badge-muted" key={id + model}>
        {name}
        <FontAwesomeIcon
          className="ms-2 clickable"
          icon={faTimes}
          size="sm"
          onClick={() => onRemoveAssociation(id, model)}
        />
      </Badge>
    );
  }

  renderTextArea() {
    const { task } = this.props;
    return (
      <div>
        <textarea
          className="textarea-minimal w-100"
          placeholder= "Enter Details..."
          value={task.body}
          onChange={this.handleTaskBodyChange}
        />
      </div>
    );
  }
}
